import { useMutation } from '@apollo/client';
import useGetUser from './useGetUser';
import LOAD_NEW_CESSIONS from '../graphql/invoices/load-new-cessions';

const useLoadNewCessions = () => {
  const user = useGetUser();

  const selectedCompanyHasSiiCredentials = Boolean(
    user?.selectedCompany && user?.selectedCompany?.hasSiiCredentials,
  );

  const [loadNewCessions, { loading, error }] = useMutation(LOAD_NEW_CESSIONS, {
    onError: () => {},
  });

  return {
    loading,
    error,
    loadNewCessions,
    selectedCompanyHasSiiCredentials,
  };
};

export default useLoadNewCessions;
